import Model from "@/models/Model"

export default class PosSaleType extends Model {
    resource() {
        return "pos_sale_type"
    }
}